<save-popup [show]="openSaveDialog" />
<breadcrumb [endText]="breadcrumbEndText" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="mb-5">
    <p class="font-medium text-xl mb-2">
      {{add? 'New' : 'Edit'}} User Role
    </p>
    <hr />
  </div>
  @if (add) {
    <div class="text-sm mb-5">
      <b>Create New User Role</b>
      <br>
        <p>This form is designed to help you create a new user role that can be assigned to any user.</p>
        <p> Required fields are marked with an asterisk <b [style]="primaryColor">(*)</b>.</p>
        <p> Please ensure that the information you provide is accurate.</p>
      </div>
    }
    <div class="grid grid-cols-3 lg:w-[75%]" [formGroup]="roleForm">
      <p>Title <b [style]="primaryColor">*</b></p>
      <input formControlName="title" type="text" placeholder="example: Guest Instructor" class="col-span-2 input" id="title" [value]="editRole.name"/>
      @if (titleValidation) {
        <div></div>
      }
      @if (titleValidation) {
        <p class="col-span-2 text-sm text-red-500 font-semibold">Title is required.</p>
      }
      <p class="mt-5">Description:</p>
      <input formControlName="description" type="text" placeholder="Description of role" class="col-span-2 mt-5 input" id="description" [value]="editRole.description" />
      <p class="mt-5">Permissions<b [style]="primaryColor">*</b></p>
      <dropdown-search [FormGroup]="roleForm" [addedList]="addedPermissions" [items]="permissionList" placeholder="Search for permissions" class="col-span-2 mt-5"/>
      <div></div>
      <div class="col-span-2 mb-3">
        @if (addedPermissions.length === 0 && checkPermission) {
          <p class="text-sm text-red-500 font-semibold">Permissions are required.</p>
        }
        @for (addedPermission of addedPermissions; track addedPermission) {
          <chip (click)="addedPermissions = removeItemFromList(addedPermission, addedPermissions)" [text]="addedPermission.name" />
        }
      </div>
      <p class="col-span-2 text-sm mb-5">At least one organization, subject or unit <b>must</b> be selected<b [style]="primaryColor">*</b></p>
      <div></div>
      <p>Choose Organization:</p>
      <dropdown-search [FormGroup]="roleForm" (change)="roleForm.markAsDirty()" [addedList]="addedOrgList" [items]="orgList" placeholder="Search for organization" class="col-span-2" />
      <div></div>
      <div class="col-span-2 mb-3">
        @for (addedOrg of addedOrgList; track addedOrg) {
          <chip (click)="addedOrgList = removeItemFromList(addedOrg, addedOrgList)" [text]="addedOrg.name" />
        }
      </div>
      <p>Choose Subject:</p>
      <dropdown-search [FormGroup]="roleForm" (change)="roleForm.markAsDirty()" formGroupName="subjects" [addedList]="addedSubjects" [items]="subjectList" placeholder="Search for subjects" class="col-span-2" />
      <div></div>
      <div class="col-span-2 mb-3">
        @for (addedSubject of addedSubjects; track addedSubject) {
          <chip (click)="addedSubjects = removeItemFromList(addedSubject, addedSubjects)" [text]="addedSubject.name" />
        }
      </div>
      <p>Choose Unit:</p>
      <dropdown-search [FormGroup]="roleForm" formControlName="units" [addedList]="addedUnits" [items]="unitList" placeholder="Search for units" class="col-span-2" />
      <div></div>
      <div class="col-span-2 mb-3">
        @for (addedUnit of addedUnits; track addedUnit) {
          <chip (click)="addedUnits = removeItemFromList(addedUnit, addedUnits)" [text]="addedUnit.name"/>
        }
      </div>
      <div></div>
      <div class="col-span-2 mt-5 flex flex-row justify-end">
        <outline-button [marginRight]="true" (click)="_location.back()" text="Exit" />
        <full-button (click)="saveRoleDialog()" text="Save" />
      </div>
    </div>
  </div>
